import Quiz, { type Round } from './Quiz';
import { entriesOf, options, ROUNDS, sample, type Entry } from './game';

const READ_MS = 10000;
const MAX = 8;
const pool = entriesOf('Movies').filter(e => e.plot);

type PlotRound = Round & { entry: Entry };

const makeRounds = (): PlotRound[] => sample(pool, ROUNDS).map(entry => ({
  key: entry.name, entry, answer: entry.name, options: options(entry),
}));

// "Badly explained plot": a deliberately terrible summary of one of the movies.
export default function BadPlot({ onExit }: { onExit: () => void }) {
  return (
    <Quiz<PlotRound>
      game="plot"
      makeRounds={makeRounds}
      maxScore={ROUNDS * MAX}
      // A little longer than the cover games, since there's reading to do.
      scoreFor={ms => Math.max(1, Math.min(MAX, Math.ceil(((READ_MS - ms) / READ_MS) * MAX)))}
      renderStage={round => (
        <div className="plot-stage">
          <span className="game-label">Which movie is this?</span>
          <p className="plot-text">“{round.entry.plot}”</p>
        </div>
      )}
      verdict={({ score }) =>
        score >= ROUNDS * MAX * 0.7 ? 'You speak fluent bad summary. Impressive.'
          : score >= ROUNDS * MAX * 0.4 ? 'Solid. You have seen a movie or two.'
            : 'In fairness, my summaries are terrible.'}
      onExit={onExit}
    />
  );
}
